import { cva } from 'class-variance-authority';
import { cn } from '@wwe-portal/ui/lib/lib';

const variants = cva('', {
  variants: {
    position: {
      default: 'inset-y-0 inset-x-1 overflow-visible -translate-y-2',
      center: 'inset-0 flex justify-center items-center',
    },
    size: {
      default: 'w-[49px] h-[49px]',
      large: 'w-[60px] h-[60px]',
    },
  },
});

export const RewardItemContainer = ({
  children,
  className,
  size = 'default',
  position = 'default',
}: {
  children: React.ReactNode;
  size?: 'default' | 'large';
  position?: 'default' | 'center';
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'bg-back200 relative rounded-lg',
        variants({ size }),
        className
      )}
    >
      <div className={cn('absolute', variants({ position }))}>{children}</div>
    </div>
  );
};
